import { render, staticRenderFns } from "./vSupplementLabelUS.vue?vue&type=template&id=6a0635ec&scoped=true"
import script from "./vSupplementLabelUS.vue?vue&type=script&lang=ts"
export * from "./vSupplementLabelUS.vue?vue&type=script&lang=ts"
import style0 from "./vSupplementLabelUS.vue?vue&type=style&index=0&id=6a0635ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0635ec",
  null
  
)

export default component.exports